import React from 'react';
import PropTypes from 'prop-types';

import { SharedZoneBlocks, SharedZoneCustomSlug } from 'store/SharedZone/blocks/selectors';

import {
  CUSTOM_COMPONENT_CALCULATOR,
  CUSTOM_COMPONENT_OFFICES_MAP,
  CUSTOM_COMPONENT_SUBSCRIBE_FORM,
  CUSTOM_COMPONENT_VOTE_FORM,
} from './constants.js';
import TradeInCalculator from '../../components/TradeInCalculator';
import OfficesMap from '../../components/OfficesMap';
import SubscribeFormWidget from '../../components/SubscribeFormWidget';
import VoteFormWidget from '../../components/VoteFormWidget';

function CustomBlockLayout({ slug }) {
  switch (slug) {
    case CUSTOM_COMPONENT_CALCULATOR:
      return <TradeInCalculator />;
    case CUSTOM_COMPONENT_OFFICES_MAP:
      return <OfficesMap />;
    case CUSTOM_COMPONENT_SUBSCRIBE_FORM:
      return <SubscribeFormWidget />;
    case CUSTOM_COMPONENT_VOTE_FORM:
      return <VoteFormWidget />;
    default:
      return null;
  }
}

CustomBlockLayout.propTypes = {
  slug: PropTypes.string,
};

const mapStateToProps = (state) => ({
  slug: SharedZoneCustomSlug.getSlug(state),
});

const CustomBlock = SharedZoneBlocks.connect(mapStateToProps)(CustomBlockLayout);

export default CustomBlock;
